import { giphyDarkGrey, giphyGreen, giphyLightestGrey, giphyRed } from '@giphy/colors'
import { useState } from 'react'
import styled from 'styled-components'
import CreationToolUIAnimation from '../types/ui-animation'

const Tag = styled.div`
    ${CreationToolUIAnimation.css(CreationToolUIAnimation.PopIn)}
    background: ${giphyDarkGrey};
    border-radius: 20px;
    box-sizing: border-box;
    color: ${giphyLightestGrey};
    display: inline-block;
    font-size: 15px;
    font-weight: normal;
    height: 40px;
    line-height: 40px;
    max-width: 100%;
    overflow: hidden;
    padding: 0 36px 0 20px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:before {
        content: '#';
    }
`

const Hit = styled.div`
    cursor: pointer;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`

const Remove = styled.div`
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-size: 11px;
    height: 20px;
    justify-content: center;
    line-height: 22px;
    position: absolute;
    right: 10px;
    text-align: center;
    top: 10px;
    user-select: none;
    vertical-align: middle;
    width: 20px;

    &:hover {
        background: #000;
    }
`

type Props = {
    className?: string
    tag: string
    isFeatured: boolean
    enableFeatured: boolean
    onRemove: (tag: string) => void
    onToggleFeatured: (tag: string) => void
}

const CreationToolTags = ({ className, tag, onRemove, isFeatured, onToggleFeatured, enableFeatured }: Props) => {
    const defaultBackground = isFeatured ? giphyGreen : undefined
    const [background, setBackground] = useState<string | undefined>(defaultBackground)
    const style = background ? { background, color: '#000' } : {}

    return (
        <Tag className={className} style={style}>
            {tag}
            {enableFeatured && (
                <Hit
                    onMouseOver={() => setBackground(giphyGreen)}
                    onMouseOut={() => setBackground(defaultBackground)}
                    onClick={() => onToggleFeatured(tag)}
                />
            )}
            <Remove
                className="ss-delete"
                onMouseOver={() => {
                    setBackground(giphyRed)
                }}
                onMouseOut={() => {
                    setBackground(defaultBackground)
                }}
                onClick={() => onRemove(tag)}
            />
        </Tag>
    )
}

export default CreationToolTags
